export const importFontello = () => {
    import(`./fontello/css/animation.css`);
    import(`./fontello/css/fontello.css`);
    import(`./fontello/css/fontello-codes.css`);
    import(`./fontello/css/fontello-embedded.css`);
};

export const importLamapollFonts = () => {
    import(`./LamapollFonts/css/animation.css`);
    import(`./LamapollFonts/css/lamapoll-icons.css`);
    import(`./LamapollFonts/css/lamapoll-icons-codes.css`);
    import(`./LamapollFonts/css/lamapoll-icons-embedded.css`);
};